export default function sendData(organization, campaign, table, data) {
    const url = `https://lottery.donors.co.il/wp-json/donors/v1/organization/${organization}/campaign/${campaign}/uploadata/${table}`;
    const token = localStorage.getItem("donors-jwt");

    let formData = new FormData();
    for (const name in data) {
        formData.append(name, data[name]);
    }

    const options = {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data, null, 1)
    };
    return fetch(url, options)
        .then((response) => {
            return response.json();
        })
        .then((jsonObject) => {
            return jsonObject;
        });
}